<template>
    <div>
        <div class="row">
            <div class="col-md-9">
                <h3>Выборка заказов</h3>
                <date-range-picker></date-range-picker>
                <div class="clearfix"></div>
                <div class="b-orders-statistics__filters-container">
                    <ul class="nav nav-tabs b-admin-form__tabs">
                        <li role="presentation" class="active">
                            <a href="#pay_types" aria-controls="pay_types" role="tab" data-toggle="tab">
                                Способы оплаты <i class="fa"></i>
                            </a>
                        </li>
                        <li role="presentation">
                            <a href="#domains" aria-controls="domains" role="tab" data-toggle="tab">
                                Домены <i class="fa"></i>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane active" id="pay_types">
                            <h3>Выбрать заказы с оплатой: </h3>
                            <div class="row">
                                <div v-for="payment_type in payment_types" class="col-md-3">
                                    <label>
                                        <input
                                                type="radio"
                                                name="payment_types[]"
                                                v-model="chosen_payment_type"
                                                :value="payment_type.code"
                                        >
                                        {{payment_type.title}}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div role="tabpanel" class="tab-pane" id="domains">
                            <h3>Выбрать заказы с доменов: </h3>
                            <div class="row">
                                <div class="col-md-12">
                                    <label style="font-size: 15px">
                                        <input v-model="is_chosen_all_domains" @change="selectAllDomains()" type="checkbox">
                                        Выбрать всё
                                    </label>
                                </div>
                                <div v-for="domain in domains" class="col-md-3">
                                    <label>
                                        <input
                                                type="checkbox"
                                                name="domains[]"
                                                v-model="chosen_domains"
                                                :value="domain.code"
                                        >
                                        {{domain.title}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <button class="btn btn-primary form-control" @click="load">
                        <span v-show="!show_loader">Выгрузить данные</span>
                        <i v-show="show_loader" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                    </button>
                </div>
                <div class="form-group" v-show="stats.length && !show_loader">
                    <button class="btn btn-success form-control" @click="toggleChart()">
                        <span v-if="show_chart">Скрыть график</span>
                        <span v-else="">Показать график</span>
                    </button>
                </div>
            </div>
        </div>
        <div v-show="show_chart">
            <div style="max-width: 1625px; max-height: 400px;">
                <canvas id="myChart" width="1625" height="400"></canvas>
            </div>
        </div>
        <div class="col-md-12" v-show="stats.length > 0">
            <h3>Всего заказов: {{ stats.length }}</h3>
        </div>
        <div class="row" v-show="stats.length > 0">
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>№</th>
                            <th v-for="column in columns" v-text="column.title"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(stat_row, key) in stats">
                            <td><b>{{ key + 1 }}.</b></td>
                            <td v-for="column in columns">{{ stat_row[column.code] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['payment_types', 'domains'],
    mounted: function() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');

        this.setColumns();
        this.initChart();
    },
    data: function () {
        let defaultPaymentType = 'yandex_kassa';

        return {
            chart: '',
            columns: [],
            chosen_payment_type: defaultPaymentType,
            is_chosen_all_payment_types: true,
            chosen_domains: this.getCodes(this.domains),
            is_chosen_all_domains: true,
            stats: [],
            show_loader: false,
            show_chart: false,
            date_start: '',
            date_finish: ''
        };
    },
    methods: {
        setColumns: function () {
            this.columns = [
                { code: 'date', title: 'Дата' },
                { code: 'quantity', title: 'Количество заказов' },
                { code: 'payment_quantity', title: 'Количество заказов ' + this.chosen_payment_name },
                { code: 'paid_quantity', title: 'Количество оплаченных заказов' },
                { code: 'paid_percent', title: 'Процент оплаты' },
            ];
        },
        getCodes: function (arr) {
            let codes = [];

            arr.forEach(function (item) {
                codes.push(item.code);
            });

            return codes;
        },
        getNormalizedArr: function (arr, key, value) {
            let columns = {};
            arr.forEach(function (item) {
                columns[item[key]] = item[value];
            });

            return columns;
        },
        load: function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (!this.checkEnteredData()) {
                alert('Заполните обязательные поля!');
                return;
            }
            this.show_loader = true;
            this.show_chart = false;

            this.$http.post(
                '/statistics/paid_orders/get',
                {
                    columns: this.getNormalizedArr(this.columns, 'code', 'title'),
                    date_start: this.date_start,
                    date_finish: this.date_finish,
                    payment_type: this.chosen_payment_type,
                    domains: this.chosen_domains
                }
            ).then(function (response) {
                this.setColumns();
                this.show_loader = false;
                this.stats = response.data;
                this.toggleChart();
            }, function (response) {
                this.show_loader = false;

                let errors = '';
                for (let field in response.data) {
                    errors += response.data[field] + '\r\n';
                }

                alert(errors);
            });
        },
        checkEnteredData: function () {
            return !!(
                this.date_start && this.date_finish && this.chosen_payment_type.length
                && this.chosen_domains.length
            );
        },
        selectAllDomains: function () {
            this.is_chosen_all_domains ? this.chosen_domains = this.getCodes(this.domains) : this.chosen_domains = [];
        },
        toggleChart: function () {
            if (!this.show_chart) {
                this.updateChartData();
            }

            this.show_chart = !this.show_chart;
        },
        initChart: function () {
            let ctx = document.getElementById("myChart");
            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [{
                        label: '% Оплаченных заказов',
                        data: [],
                        borderColor: 'rgba(54,162,235,1)',
                        backgroundColor: 'rgba(54,162,235,0.2)',
                        fill: false,
                        borderWidth: 1
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepValue: 5,
                                max: 100
                            }
                        }]
                    }
                }
            });
        },
        updateChartData: function () {
            let data = this.getChartData();
            this.chart.data.labels = data.dates;
            this.chart.data.datasets[0].data = data.percents;

            this.chart.update();
        },
        getChartData: function () {
            let stats = this.stats;
            let data = {
                dates: [],
                percents: [],
                quantity: [],
            };

            for (let i = 0; i < stats.length; i++) {
                data.dates.push(stats[i]['date']);
                data.quantity.push(stats[i]['payment_quantity']);
                data.percents.push(stats[i]['paid_percent'] ? stats[i]['paid_percent'].split('.')[0] : 0);
            }

            return data;
        },
    },
    computed: {
        chosen_payment_name: function () {
            for (let i = 0; i < this.payment_types.length; i++) {
                if (this.payment_types[i].code === this.chosen_payment_type) {
                    return this.payment_types[i].title;
                }
            }
        }
    },
    created: function () {
        this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; });
    }
};
</script>
